// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo__1G9oD","sectionA":"sectionA__2MM6o","glowA":"glowA__jEsh5","sectionB":"sectionB__oQjvu","glowB":"glowB___8MkC"};